<div class="filterLine">

	<mat-form-field
		subscriptSizing="dynamic"
		appearance="outline"
		class="filterField"
	>

		<mat-label>Filter</mat-label>
		<mat-select [formControl]="filterCtrl">
			<mat-option value="">Alles</mat-option>
			<mat-option value="past">Vergangene Veranstaltungen</mat-option>
			<mat-option value="future">Zukünftige Veranstaltungen</mat-option>
		</mat-select>

	</mat-form-field>

</div>

<table
	matSort 
	(matSortChange)="sortData($event)"
	[matSortDisableClear]="true"
	[matSortActive]="'startDate'"
	[matSortDirection]="'desc'"
>

	<tr>
		<th mat-sort-header="eventName">Veranstaltungsname</th>
		<th mat-sort-header="startDate">Date</th>
		<th mat-sort-header="bReleased">Veröffentlicht</th>
		<th *ngIf="isInternalCalendar" mat-sort-header="nurIntern">Verfügbarkeit</th>
	</tr>

	<tr
		*ngFor="let event of filteredEvents" 
		(click)="eventClicked(event)"
		class="mousePointer"
		[ngClass]="{'internal-event': event.nurIntern}"

	>
		<td>{{ (event.name.length > nbCharMax) ? (event.name | slice:0:nbCharMax) + '…' : event.name }}</td>
		<td>

			<div style="display: flex; flex-flow: row wrap; row-gap: 0; column-gap: .5em; word-break: keep-all;">
				<span>{{ event.tmsStart | date: "dd.MM.YYYY" }}</span>
				<span>{{ event.tmsStart | date: "HH:mm" }}</span>
			</div>
			
		</td>
		<td style="text-align: center;">
			<span *ngIf="event.bReleased" class="material-icons">
				cell_tower
			</span>
			<!--
			<span *ngIf="!event.bReleased" class="material-icons">
				check_box_outline_blank
			</span>
			-->
		</td>
		<td *ngIf="isInternalCalendar" style="text-align: center;">
			<span class="material-icons lock" *ngIf="event.nurIntern" matTooltip="Intern">lock</span>
			<span class="material-icons public" *ngIf="!event.nurIntern" matTooltip="Öffentlich">public</span>
		</td>

	</tr>

	@if( !bLoading && !filteredEvents.length ) {
		<tr>
			<td colspan="4" class="noResults">
				Keine Veranstaltung gefunden
			</td>
		</tr>
	}

</table>

